<template>
  <ModalBase :show="show" @close="close()">
    <transition name="transition-fade">
      <div v-if="success">
          <h3 class="modal-heading">Skickat!</h3>
          <span class="alert alert-success">
            <i class="fas fa-check"></i>Din anmälan har skickats
          </span>
      </div>
      <div v-else>
        <h3 class="modal-heading">Anmäl annons</h3>
        <ul class="alert alert-error-list" v-show="Object.keys(errors).length">
          <li class="alert-error-list-item" v-for="(error, index) in errors" :key="index">{{ error }}</li>
        </ul>
        <form class="modal-form" novalidate @submit.prevent="validate()">
          <input class="modal-input" type="text" placeholder="Namn" maxlength="50" :class="{ error: errors.name }" v-model.trim="form.name">
          <input class="modal-input" type="email" placeholder="Epost" maxlength="100" autocorrect="off" autocapitalize="off" :class="{ error: errors.email }" v-model.trim="form.email">
          <textarea class="modal-input" rows="5" placeholder="Beskriv din anmälan..." maxlength="3000" v-model.trim="form.message"></textarea>
          <button class="button-reset button-base button-primary modal-submit-button" type="submit" :class="{ 'button-primary-active': posting }" :disabled="posting">
            <i class="fas fa-paper-plane"></i><i v-if="posting">Ett ögonblick...</i><span v-else>Skicka anmälan</span>
          </button>
        </form>
      </div>
    </transition>
  </ModalBase>
</template>

<script>
import axios from 'axios'
import ModalBase from '@/components/ModalBase.vue'
import { minLength, validEmail } from '@/library/form-validators.js'

export default {
  name: 'ItemReport',
  props: ['show', 'itemId'],
  components: {
    ModalBase
  },
  data () {
    return {
      posting: false,
      success: false,
      errors: {},
      form: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    validate () {
      if (Object.keys(this.errors).length) {
        this.errors = {}
      }

      if (!minLength(this.form.name, 1)) {
        this.$set(this.errors, 'name', 'Namn saknas')
      }
      if (!minLength(this.form.email, 1)) {
        this.$set(this.errors, 'email', 'Epostadress saknas')
      } else if (!validEmail(this.form.email)) {
        this.$set(this.errors, 'email', 'Epostadressen har ogiltigt format')
      }

      if (!Object.keys(this.errors).length) {
        this.submit()
      }
    },
    submit () {
      this.posting = true

      axios.post(process.env.VUE_APP_API_ENDPOINT + '/actions/report', {
        itemId: this.itemId,
        name: this.form.name,
        email: this.form.email,
        message: this.form.message
      })
      .then(() => {
        this.success = true
        this.posting = false
      })
      .catch(() => {
        this.$set(this.errors, 'error', 'Ett fel inträffade, anmälan kunde inte skickas')
        this.posting = false
      })
    }
  },
  watch: {
    'form.name' () {
      if (this.errors.name) {
        this.$delete(this.errors, 'name')
      }
    },
    'form.email' () {
      if (this.errors.email) {
        this.$delete(this.errors, 'email')
      }
    }
  }
}
</script>
